import React, { Fragment } from 'react';
import { Row, Col,Table } from 'reactstrap';
import convertToRupees from '../../../../../utilities/convertToRupees';


const Fees = ({ data }) => {

    return (
        <Fragment>
            <Row className='mt-4'>
                <Col sm="12" >
                    <Table>
                        <tbody>
                            <tr>
                                <th>DC Amount</th>
                                <td className="text-right pr-5">{convertToRupees(data.br_dc_amount) || '-'}</td>
                            </tr>
                            <tr>
                                <th>Dealer Commission Type</th>
                                <td className="text-right pr-5">{data.br_dc_amount == 0 ? 'NA' : data.dealer_commission_type || '-'}</td>
                            </tr>
                            <tr>
                                <th>Claimable Dealer Commission</th>
                                <td className="text-right pr-5">{convertToRupees(data.dealer_commission) || '-'}</td>
                            </tr>
                            <tr>
                                <th>Upfront Dealer Commission</th>
                                <td className="text-right pr-5">{data.upfront_dc || '-'}</td>
                            </tr>
                            <tr>
                                <th>Discount on Dealer Commission</th>
                                <td className="text-right pr-5">{convertToRupees(data.discount_on_dealer_commission) || '-'}</td>
                            </tr>
                            <tr>
                                <th>Tax Type</th>
                                <td className="text-right pr-5">GST - {data.tax_type ? `${data.tax_type}%` : '-'}</td>
                            </tr>
                            <tr>
                                <th>Price To Dealer</th>
                                <td className="text-right pr-5">{convertToRupees(data.selling_price) || '-'}</td>
                            </tr>
                            {data?.upfront_dc > 0 && (
                            <tr>
                                <th>Price To Customer</th>
                                <td className="text-right pr-5">{convertToRupees(data.selling_price + data.upfront_dc + data?.upfront_dc_tax) || '-'}</td>
                            </tr>
                            )}
                        </tbody>
                    </Table>
                </Col>
            </Row>
        </Fragment>
    );
};

export default Fees;